import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class StacErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('[STAC] Component error:', error, info.componentStack);
  }

  handleRetry = (): void => {
    this.setState({ hasError: false, error: null });
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ margin: 32, padding: 28, background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, fontFamily: 'Inter, system-ui, sans-serif', maxWidth: 560 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <span style={{ fontSize: 22 }}>⚠️</span>
            <div>
              <div style={{ fontWeight: 600, color: '#991B1B', fontSize: 15, marginBottom: 6 }}>
                Something went wrong in Tax &amp; Compliance
              </div>
              <div style={{ color: '#6B7280', fontSize: 13, marginBottom: 18, lineHeight: 1.5 }}>
                {this.state.error?.message ?? 'An unexpected error occurred. The rest of your dashboard is unaffected.'}
              </div>
              <button
                onClick={this.handleRetry}
                style={{ padding: '8px 18px', background: '#1B4F8C', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 500 }}
              >
                Try again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
